import { Flag } from "@medbillai/utils/flag";
import type { ScreenViewProps } from "../../components/ScreenView";
import { HOME_SCREEN_VIEWED_VARIANTS } from "../../lib/analytics/types";
import { useEnumVariation } from "../../lib/flag";
import { HomeContent } from "./components/HomeContent";
import { LegacyHomeContent } from "./components/LegacyHomeContent";
export type HomeScreenProps = {
  screenViewProps?: Omit<ScreenViewProps, "children">;
};
export function HomeScreen({
  screenViewProps
}: HomeScreenProps) {
  // The flag value IS the experiment arm (LD serves `experiment-legacy` /
  // `experiment-redesign` to enrolled users, `legacy` to everyone else) and
  // doubles as the HomeScreenViewed tag.
  const variant = useEnumVariation(HOME_SCREEN_VIEWED_VARIANTS, Flag.HOMEPAGE_REDESIGN_EXPERIMENT, "legacy");
  const redesignEnabled = variant === "experiment-redesign";
  return redesignEnabled ? <HomeContent variant={variant} screenViewProps={screenViewProps} data-sentry-element="HomeContent" data-sentry-component="HomeScreen" data-sentry-source-file="screen.tsx" /> : <LegacyHomeContent variant={variant} screenViewProps={screenViewProps} data-sentry-element="LegacyHomeContent" data-sentry-component="HomeScreen" data-sentry-source-file="screen.tsx" />;
}